<template>
    <div class="main">
        <tab title='我的'></tab>
        <van-cell-group >
            <van-cell title="修改密码" is-link @click="toupdPw"/>
            <van-cell title="解除绑定" v-if="flg==1" is-link @click="jie"/>
        </van-cell-group>
        
    </div>
  </template>
  
  <script>
  import Vue from 'vue';
  import tab from '@/components/NavBar'
  import { Cell, CellGroup,Dialog } from 'vant';

    Vue.use(Cell);
    Vue.use(CellGroup);
    Vue.use(Dialog);
  export default {
    name: 'margin',
    data () {
      return {
        flg:'',//1为自动登录 可显示
      }
    },
    components:{
        tab
    },
    mounted(){
        this.flg = sessionStorage.getItem('autoLogin')
    },
    methods:{
        jie(){
            Dialog.confirm({
                title: '温馨提示',
                message: '请确认解除与此账号绑定',
            })
            .then(() => {
                // on confirm
                this.jiebang()
            })
        },
        toupdPw(){
            this.$router.push("upd_password");
        },
        jiebang(){
            var data = {
                mobile:sessionStorage.getItem('mobile'),
                openId:sessionStorage.getItem('openid')
            }
            data.token = this.$storage.get('token')
            this.$api.post('orgapp/cancel',data,response=>{
                console.log(response.data)
                var data = response.data
                if(data.code == 0){
                    sessionStorage.setItem('autoLogin',0)
                    this.flg = 0
                    Dialog.alert({
                    title: '温馨提示',
                    message: '解绑成功',
                    }).then(() => {
                    // on close
                    });
                }
            })
        },
    }
  }
  </script>
  
  <style scoped>
  .main {
    height: 100vh;
    background-color: #F7F8FA;
  }
  </style>
  


// WEBPACK FOOTER //
// src/components/wode.vue